

















import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';

export default defineComponent({
    name: 'ComparisonRow',
    props: {
        mergeWithNextRow: { type: Boolean, required: false },
        notPrintable: { type: Boolean, required: false },
        valueCellClass: { type: String, default: '' },
        isValueRow: { type: Boolean, required: false },
        isVerticalCentered: { type: Boolean, default: false }
    },
    setup () {
        const store = useStore();
        const items = computed(() => store.getters.getVisibleTickedItems);
        const notEmptyItems = computed(() => store.getters.notEmptyComparingItems);
        return { items, notEmptyItems };
    }
});
